import MaterialTable, {
  MaterialTableProps,
  MTableToolbar,
  MTableBodyRow,
  MTableCell,
  MTableHeader,
  Localization,
} from "@material-table/core";
import { options as defaultOptions } from "./options";
import { useIntl } from "react-intl";
import { Paper, PaperProps } from "@material-ui/core";
import { useStyles } from "./MTable.styles";
export const MTable = <RowData extends object>(
  props: MaterialTableProps<RowData> & {
    actionLabel?: string;
    hideToolbar?: boolean;
  }
) => {
  const classes = useStyles();
  const intl = useIntl();
  const { options, ...rest } = props;
  return (
    <MaterialTable
      localization={
        {
          pagination: {
            firstTooltip: intl.formatMessage({
              id: "component.mtable.firstTooltip",
            }),
            labelDisplayedRows: intl.formatMessage({
              id: "component.mtable.labelDisplayedRows",
            }),
            labelRowsPerPage: intl.formatMessage({
              id: "component.mtable.labelRowsPerPage",
            }),
            labelRowsSelect: intl.formatMessage({
              id: "component.mtable.labelRowsSelect",
            }),
            lastTooltip: intl.formatMessage({
              id: "component.mtable.lastTooltip",
            }),
            nextTooltip: intl.formatMessage({
              id: "component.mtable.nextTooltip",
            }),
            previousTooltip: intl.formatMessage({
              id: "component.mtable.previousTooltip",
            }),
            labelRows: intl.formatMessage({
              id: "component.mtable.labelRowsSelect",
            }),
          },
          body: {
            dateTimePickerLocalization: { locale: "en-US" },
            addTooltip: intl.formatMessage({
              id: "component.mtable.addTooltip",
            }),
            deleteTooltip: intl.formatMessage({
              id: "component.mtable.deleteTooltip",
            }),
            editRow: intl.formatMessage({ id: "component.mtable.editRow" }),
            editTooltip: intl.formatMessage({
              id: "component.mtable.editTooltip",
            }),
            emptyDataSourceMessage: intl.formatMessage({
              id: "component.mtable.emptyDataSourceMessage",
            }),
            filterRow: intl.formatMessage({ id: "component.mtable.filterRow" }),
          },
          grouping: {
            groupedBy: intl.formatMessage({ id: "component.mtable.groupedBy" }),
            placeholder: intl.formatMessage({
              id: "component.mtable.placeholder",
            }),
          },
          header: {
            actions:
              props.actionLabel !== undefined
                ? props.actionLabel
                : intl.formatMessage({ id: "component.mtable.actions" }),
          },
          toolbar: {
            addRemoveColumns: intl.formatMessage({
              id: "component.mtable.addRemoveColumns",
            }),
            exportName: intl.formatMessage({
              id: "component.mtable.exportName",
            }),
            exportTitle: intl.formatMessage({
              id: "component.mtable.exportTitle",
            }),
            nRowsSelected: intl.formatMessage({
              id: "component.mtable.nRowsSelected",
            }),
            searchPlaceholder: intl.formatMessage({
              id: "component.mtable.searchPlaceholder",
            }),
            searchTooltip: intl.formatMessage({
              id: "component.mtable.searchTooltip",
            }),
            showColumnsTitle: intl.formatMessage({
              id: "component.mtable.showColumnsTitle",
            }),
          },
        } as Localization
      }
      components={{
        Toolbar: (props: JSX.IntrinsicAttributes) => (
          <MTableToolbar {...props} classes={{ root: classes.toolbar }} />
        ),
        Row: (props: JSX.IntrinsicAttributes) => (
          <MTableBodyRow {...props} classes={{ root: classes.row }} />
        ),
        Cell: (props: JSX.IntrinsicAttributes) => (
          <MTableCell {...props} classes={{ root: classes.cell }} />
        ),
        Header: (props: JSX.IntrinsicAttributes) => (
          <MTableHeader {...props} classes={{ header: classes.headerCell }} />
        ),
        Container: (props: JSX.IntrinsicAttributes & PaperProps) => (
          <Paper variant="outlined" {...props} />
        ),
      }}
      style={{ fontFamily: ' "Work Sans", "Arial", "sans-serif"' }}
      options={{ ...options, ...defaultOptions, toolbar: !props.hideToolbar }}
      {...rest}
    />
  );
};
export default MTable;
